// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1LHAW","file":"styles_file__2jRnD"};